import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../../assets/svg/eye.svg';
import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import addIcon from '../../../assets/svg/add-icon-v2.svg'
import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import saveIcon from '../../../assets/svg/save-icon.svg';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'


import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import { fi, id, th } from 'react-date-range/dist/locale';
import CustomCalendarFilterSelect from '../../calendar/customCalendarFilterSelect';
import SearchPatientsField from './searchPatientsField';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import { getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class PaymentMethodsField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            paymentMethods: [],
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        let form = {
            paymentMethods: [],
            attachedInvoice: null,
        }


        this.setState({ form }, () => {
            this.onChange();
        })
    }
    checkPaymentMethods = () => {

        const groupData = this.getGroupData();

        const paymentMethods = getGroupPaymentMethods(groupData, this.props.lang);

        let setObj = { paymentMethods };

        this.setState(setObj)
    }


    get = () => {

    }


    componentDidMount() {
        this.get();
        this.checkPaymentMethods();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.price !== this.props.price) {
            this.onChange();
        }

    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }


    uploadDocument = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {

            let fsize = input.files[0].size;
            let file = Math.round((fsize / 1024))
            this.setState({
                uploadTimestampDoc: Math.floor(new Date().getTime() / 1000)
            })
            if (file > 10240) {
                this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
            } else {

                if (!this.props.handleFileUpload) this.setState({
                    _documentUploading: true
                })

                let formData = new FormData();
                formData.append('file', input.files[0]);
                formData.append('group', this.props.selectedGroup);
                formData.append('fileType', 'invoices')

                if (this.props.handleFileUpload) {
                    this.props.handleFileUpload?.('/data/upload-document', formData)?.then?.(result => {
                        if (result) {
                            this.setState({
                                attachedInvoiceFile: result,
                                _documentUploading: null
                            })
                        }
                    })
                    return;
                }

                fetch(API_ENDPOINT + '/data/upload-document', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    },
                    body: formData
                }).then(parseText).then(({ result, status }) => {
                    if (status != 200) {
                        this.setState({ error: result.translate(this.props.lang) })
                    } else {
                        this.setState({
                            attachedInvoiceFile: result,
                            _documentUploading: null
                        })
                    }
                })
            }
        }
    }

    toggleAttachInvoiceModal = () => {
        this.setState({ attachInvoiceModal: !this.state.attachInvoiceModal, attachedInvoiceFile: null })
    }



    onChange = () => {
        const form = this.state.form;
        if (this.props.onChange) {
            this.props.onChange({
                ...form,
                errors: this.checkValidation()
            });
        }
    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};

        if (!form?.paymentMethods?.length) {
            errors.paymentMethods = 'Payment method is required'.translate(this.props.lang);
        }
        if (
            form?.paymentMethods?.length === 1
            && form?.paymentMethods?.[0] === 'invoice'
            && !form?.attachedInvoice
        ) {
            errors.attachedInvoice = 'The invoice must be attached'.translate(this.props.lang);
        }

        if (JSON.stringify(this.state.errors) !== JSON.stringify(errors)) {
            this.setState({ errors });
        }

        return Object.keys(errors).length ? errors : null;
    }

    render() {

        const paymentMethods = this.state.paymentMethods ?? [];
        const errors = this.state.errors && this.props.showError ? this.state.errors : {};

        return (
            <div className='create-payment-modal-wrap'>
                <div className='create-payment-modal-body'>

                    <FormGroup className={errors.paymentMethods ? 'fg-has-error' : ''}>
                        <Label>{'Payment method'.translate(this.props.lang)}</Label>
                        <div className='payment-methods-items-wrap'>
                            {
                                paymentMethods?.map((item, idx) => {
                                    const isChecked = this.state.form?.paymentMethods?.includes(item.value);
                                    const isDisabled = false;
                                    return (
                                        <div key={idx} className='payment-method-item'>
                                            <Checkbox
                                                checked={isChecked}
                                                disabled={isDisabled}
                                                onChange={() => {
                                                    if (isDisabled) return;
                                                    let form = this.state.form;
                                                    if (form.paymentMethods?.includes(item.value)) {
                                                        form.paymentMethods = form.paymentMethods.filter(method => method !== item.value);
                                                    } else {
                                                        form.paymentMethods = [...(form.paymentMethods || []), item.value];
                                                    }
                                                    let setObj = { form };
                                                    if (this.state.errors?.paymentMethods) {
                                                        let errors = this.state.errors;
                                                        delete errors.paymentMethods;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj, () => {
                                                        this.onChange();
                                                    });
                                                }}
                                                label={
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                                                        {item.label}
                                                        {
                                                            isChecked && item.value === 'invoice' ?
                                                                <div className='icon-with-tooltip-wrap' onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    let attachedInvoiceFile = this.state.form?.attachedInvoice ?? null;
                                                                    this.setState({ attachInvoiceModal: true, attachedInvoiceFile });
                                                                }}>
                                                                    <Isvg src={attachInvoice} className={errors?.attachedInvoice ? 'attached-invoice-icon-error' : this.state.form?.attachedInvoice ? 'attached-invoice-icon' : ''} />
                                                                    <div className='tooltip-text'>
                                                                        {
                                                                            !this.state.form?.attachedInvoice ?
                                                                                'Attach invoice'.translate(this.props.lang)
                                                                                :
                                                                                'Invoice successfully attached'.translate(this.props.lang)
                                                                        }
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>
                                                }
                                            />

                                        </div>
                                    )
                                })
                            }
                        </div>
                        {errors?.paymentMethods ? <div className='error-feedback'>{errors.paymentMethods}</div> : this.state.form?.paymentMethods?.includes('invoice') && errors?.attachedInvoice ? <div className='error-feedback'>{errors.attachedInvoice}</div> : null}
                    </FormGroup>

                    <input ref={(node) => this.documentInput = node} type="file" accept=".pdf" key={this.state.uploadTimestampDoc} onChange={this.uploadDocument} style={{ pointerEvents: 'none', opacity: 0 }} />

                    {
                        this.state.attachInvoiceModal ?
                            <Modal
                                isOpen={this.state.attachInvoiceModal}
                                centered
                                toggle={() => this.toggleAttachInvoiceModal()}
                            >
                                <ModalHeader toggle={() => this.toggleAttachInvoiceModal()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggleAttachInvoiceModal()}><Isvg src={xIcon} /></button>}>{'Attach invoice'.translate(this.props.lang)}</ModalHeader>

                                <ModalBody style={{ width: '100%' }}>

                                    <button
                                        className={this.state._documentUploading ? 'attach-invoice uploading' : this.state.attachedInvoiceFile ? 'attach-invoice uploaded' : "attach-invoice"}
                                        onClick={() => {
                                            if (this.documentInput) this.documentInput.click()
                                        }}
                                    >
                                        <div className="button-menu-icon-wrap">
                                            <Isvg src={attachInvoice} />
                                        </div>
                                        <div className='chat-icons-text'>
                                            {
                                                this.state.attachedInvoiceFile ?
                                                    'File uploaded'.translate(this.props.lang)
                                                    :
                                                    'Attach file'.translate(this.props.lang)
                                            }
                                        </div>
                                    </button>


                                </ModalBody>
                                <ModalFooter className='buttons-right-blue'>
                                    <Button
                                        color='primary'
                                        disabled={!this.state.attachedInvoiceFile}
                                        onClick={() => {
                                            let form = this.state.form;
                                            form.attachedInvoice = this.state.attachedInvoiceFile;
                                            let setObj = { form };
                                            if (this.state.errors?.attachedInvoice) {
                                                let errors = this.state.errors;
                                                delete errors.attachedInvoice;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj, () => {
                                                this.toggleAttachInvoiceModal();
                                                this.onChange();
                                            });
                                        }}
                                    >
                                        {'Save'.translate(this.props.lang)}
                                    </Button>
                                    <Button color='primary' onClick={() => this.toggleAttachInvoiceModal()}>{'Close'.translate(this.props.lang)}</Button>

                                </ModalFooter>


                            </Modal>
                            :
                            null
                    }

                    {this.state._documentUploading ?
                        <div className="file-progress-loader">
                            <div>
                                <Player
                                    onEvent={(event) => {
                                        if (event === "load" && this.player && this.player.current) this.player.current.play();
                                    }}
                                    ref={this.player} // set the ref to your class instance
                                    autoplay={true}
                                    loop={true}
                                    controls={true}
                                    src="/lf30_editor_l5cxzdyf.json"
                                    renderer={'svg'}
                                    style={{ height: "128px", width: "128px", }}
                                ></Player>
                                <h6>{'Processing file...'.translate(this.props.lang)}</h6>
                            </div>
                        </div>
                        : null}

                </div>
            </div>
        );
    }
}


export default PaymentMethodsField;